import {useEffect} from 'react';

const useClose = (onBack) => {
  useEffect(() => {
    return () => onBack();
  }, [onBack]);
};

export default useClose;
